export default "__VITE_ASSET__fbe3af3f__"